import { render, staticRenderFns } from "./HeroStatsBar.vue?vue&type=template&id=1ef766d6&scoped=true"
import script from "./HeroStatsBar.vue?vue&type=script&lang=js"
export * from "./HeroStatsBar.vue?vue&type=script&lang=js"
import style0 from "./HeroStatsBar.vue?vue&type=style&index=0&id=1ef766d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef766d6",
  null
  
)

export default component.exports